const DEFAULT_GOLD_QUANTITY_DECIMAL_PLACES = '8'
const MAX_GOLD_QUANTITY_DECIMAL_PLACES = 8

const isValidGoldQuantityDecimalPlaces = (value: string) =>
  /^\d$/.test(value) && Number(value) >= 0 && Number(value) <= MAX_GOLD_QUANTITY_DECIMAL_PLACES

const getGoldQuantityDecimalPlacesPreferenceKey = (userId?: number, companyId?: number) =>
  `megapay:gold-cost-price:quantity-decimal-places:${userId ?? 'anonymous'}:${
    companyId ?? 'no-company'
  }`

const loadGoldQuantityDecimalPlacesPreference = (userId?: number, companyId?: number) => {
  if (typeof window === 'undefined') return DEFAULT_GOLD_QUANTITY_DECIMAL_PLACES

  try {
    const storedValue = window.localStorage.getItem(
      getGoldQuantityDecimalPlacesPreferenceKey(userId, companyId)
    )
    return storedValue && isValidGoldQuantityDecimalPlaces(storedValue)
      ? storedValue
      : DEFAULT_GOLD_QUANTITY_DECIMAL_PLACES
  } catch {
    return DEFAULT_GOLD_QUANTITY_DECIMAL_PLACES
  }
}

const saveGoldQuantityDecimalPlacesPreference = (
  value: string,
  userId?: number,
  companyId?: number
) => {
  if (typeof window === 'undefined' || !isValidGoldQuantityDecimalPlaces(value)) return

  try {
    window.localStorage.setItem(
      getGoldQuantityDecimalPlacesPreferenceKey(userId, companyId),
      value
    )
  } catch {
    // Storage may be unavailable in private or restricted browser contexts.
  }
}

export {
  DEFAULT_GOLD_QUANTITY_DECIMAL_PLACES,
  MAX_GOLD_QUANTITY_DECIMAL_PLACES,
  isValidGoldQuantityDecimalPlaces,
  loadGoldQuantityDecimalPlacesPreference,
  saveGoldQuantityDecimalPlacesPreference,
}
